import dynamic from 'next/dynamic';

import { fetchCategoriesWithProducts } from 'src/services/catalog';
import { AsyncTransformer } from 'src/types/Transformer';
import { lazyLoadImages } from 'src/utils/images';
import { CategoryCarouselSectionProps } from '../../../components/sections/CategoryCarouselSection';
import { SectionRenderer } from '../../../types/Section';
import { categoryContentToModel } from './contentToModel';
import { CategoryCarouselSectionContent, ContentCategory } from './types';
import { validateCategoryCarousel } from './validation';

const getCategoryProductPairs = (categories: ContentCategory[]) =>
  categories.map((item) => ({
    categoryId: item.category_id,
    productCode: item.product_code,
  }));

/* istanbul ignore next */
export const renderer: SectionRenderer<CategoryCarouselSectionProps> =
  dynamic<CategoryCarouselSectionProps>(() =>
    import('../../../components/sections/CategoryCarouselSection').then(
      (mod) => mod.CategoryCarouselSection,
    ),
  );

export const transformer: AsyncTransformer<
  CategoryCarouselSectionContent,
  CategoryCarouselSectionProps
> = async ({ _metadata, carousel_title, categories, tracking_title }, { positionMetadata }) => {
  const categoryProductPairs = getCategoryProductPairs(categories);
  const categoryProductData = await fetchCategoriesWithProducts(categoryProductPairs);

  return {
    uid: _metadata.uid,
    props: {
      title: carousel_title,
      categories: categoryProductData
        ? categoryContentToModel(categoryProductData, categories)
        : [],
      lazyImages: lazyLoadImages(positionMetadata.position),
      trackingTitle: tracking_title,
    },
    errors: validateCategoryCarousel(categories, categoryProductData),
  };
};
